export const environment = {
  production: true,
  jwtName: 'a4tok',
  apiUrl: 'https://inventortek.com/api/'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts